export default __webpack_public_path__ + "static/media/kid_star.07463a43.svg";